import { useState } from "react";


const ImageCompressor = () => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [quality, setQuality] = useState(0.7); // default 70%
  const [qualityInput, setQualityInput] = useState("70"); // Track raw user input
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleDownload = () => {
    if (!image) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");

        const finalWidth = width ? parseInt(width) : img.width;
        const finalHeight = height ? parseInt(height) : img.height;

        canvas.width = finalWidth;
        canvas.height = finalHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, finalWidth, finalHeight);

        canvas.toBlob(
          (blob) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "compressed-image.jpg";
            link.click();
          },
          "image/jpeg",
          parseFloat(quality)
        );
      };
    };

    reader.readAsDataURL(image);
  };

  const handleReset = () => {
    setImage(null);
    setPreview(null);
    setQuality(0.7);
    setWidth("");
    setHeight("");
    document.getElementById("imageUpload").value = "";
  };

  return (
      <div>
        <h2 className="mb-4">Advanced Image Compressor</h2>

        <input
          id="imageUpload"
          type="file"
          accept="image/*"
          className="form-control mb-3"
          onChange={handleImageChange}
        />

        {preview && (
          <>
            <div className="mb-3">
              <img src={preview} alt="Preview" className="img-fluid" style={{ maxHeight: "300px" }} />
            </div>

            <div className="row mb-3">
              <div className="col">
                <label>Width (px)</label>
                <input
                  type="number"
                  className="form-control"
                  value={width}
                  onChange={(e) => setWidth(e.target.value)}
                  placeholder="Auto"
                />
              </div>
              <div className="col p-0">
                <label>Height (px)</label>
                <input
                  type="number"
                  className="form-control"
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}
                  placeholder="Auto"
                />
              </div>
              <div className="col">
                <label>Quality (%)</label>
                <input
                    type="number"
                    className="form-control"
                    value={qualityInput}
                    onChange={(e) => {
                    const val = e.target.value;
                    setQualityInput(val);

                    const num = parseFloat(val);
                    if (!isNaN(num) && num >= 0 && num <= 100) {
                        setQuality(num / 100);
                    }
                    }}
                    placeholder="Quality (%)"
                    min="0"
                    max="100"
                />
                </div>
            </div>

            <button className="btn btn-success me-2 bigsize" onClick={handleDownload}>
              Compress & Download
            </button>
            <button className="btn btn-danger bigsize" onClick={handleReset}>
              Remove Image
            </button>
          </>
        )}
      </div>
  );
};

export default ImageCompressor;
